import { Injectable } from "@angular/core";

declare let gtag: Function;

@Injectable()
export class GoogleAnalyticsService {
  public eventEmitter(
    eventName: string,
    eventCategory: string,
    emailDomain: string,
    eventEnabled: boolean = null,
  ) {
    gtag("event", eventName, {
      eventCategory,
      eventEnabled,
      emailDomain,
    });
  }
}
